<div class="month-container">
    <div class="day day-row" *ngFor='let day of weekdays'>
        <div class="day-text">{{day | translate | uppercase}}</div>
    </div>
    <ng-container *ngFor='let date of dateArray; let i = index'>
        <div class="date day-row" *ngIf="isDateWithinMonthRange(date.date)"   (click)='dateSelection(i)' [ngClass]="setClass(date.date)" [ngStyle]="{'border-top-style': i < 7 ? 'none' : 'solid'}">
          <div class="row"> 
          <div class="date-text" [ngClass]="setClass(date.date)" > {{ getTransformed(date.date) }} </div>
          <span *ngIf='date.bookingPercentage !== null && !(checkDateWithinCacheLimit(date))' [ngClass]="setClass(date.date)" 
            [ngStyle]="{'background-image' : getStatusImage(date) }"
            class="statusSpan d-inline-flex"></span>
          </div>
        <div class='slot-text' *ngIf='!(isSlotLoading$ | async)' [ngClass]="setClass(date.date)"
          [ngStyle]="{'background-color': '#0E131933' }">
          {{ 'serviceSchedule.loading' | translate}}
        </div>
        <div class='slot-text' *ngIf='(isSlotLoading$ | async)' [ngClass]="setClass(date.date)">
          <span [ngStyle]="{'background-color': getBackgroundColor(date.bookingPercentage, 'slots')}">{{(checkDateWithinCacheLimit(date)) ? ('serviceSchedule.notApplicable' | translate) : ((date.bookingPercentage !== null && date.bookingPercentage !== -1) ? date.noOfSlotsLeft + ('serviceSchedule.slotsLeft' | translate) : date.bookingPercentage === -1 ? ('serviceSchedule.noSlots' | translate) : ('serviceSchedule.closed' | translate))}}</span>
        </div>
        <div class='slot-text' [ngClass]="setClass(date.date)" *ngIf='department === "SERVICE" && (isSlotLoading$ | async) && date.bookingPercentageHrs !== null && !(checkDateWithinCacheLimit(date))'
          [ngStyle]="{'background-color': getBackgroundColor(date.bookingPercentageHrs, 'Hrs')}">
           {{(date.bookingPercentageHrs !== null && date.bookingPercentageHrs !== -1) ? date.noOfHrsLeft + ('serviceSchedule.hoursLeft' | translate) : date.bookingPercentageHrs === -1 ? '0'+('serviceSchedule.hoursLeft' | translate) : ''}}
        </div>
      </div>
      
    
  </ng-container>
</div>